<!--
 * @Author: your name
 * @Date: 2020-10-27 16:31:00
 * @LastEditTime: 2020-11-03 09:50:35
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /ShopExpressEdition/src/components/common/babySubmitBtn/babySubmitBtn.vue
-->
<template>
  <div class="submit" :style="{top: top ? top + 'px' : '300px'}">
    <img src="@/assets/img/WechatIMG1225.png" alt="" />
    <span class="desc">
      <slot></slot>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    top: {}
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.submit {
  position: fixed;
  right: 40px;
  font-size: 18px;
  color: #fff !important;
  cursor: pointer;
  .desc {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    white-space: nowrap;
  }
}
</style>
